import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-training',
  templateUrl: './training-trends-skill.component.html',
  styleUrls: ['./training-trends-skill.component.scss']
})
export class TrainingTrendsSkillsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
